module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_10_1-8549a789ad518565c0e14cd2f8e1a45a.svg";